import { render, staticRenderFns } from "./BenefitVoucherFormFields.vue?vue&type=template&id=5932116f&scoped=true"
import script from "./BenefitVoucherFormFields.vue?vue&type=script&lang=js"
export * from "./BenefitVoucherFormFields.vue?vue&type=script&lang=js"
import style0 from "./BenefitVoucherFormFields.vue?vue&type=style&index=0&id=5932116f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932116f",
  null
  
)

export default component.exports